import React, { createContext, useReducer } from 'react';
import axios from '../../../axios';
import useError from "../../hooks/useError";
import SessionOut from "../../views/sessions/SessionOut";

const initialValue = {};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_CUSTOMER_DATA': {
            return {
                ...state,
                customer: action.payload,
            }
        }
        case 'UPDATE_CUSTOMER_DATA': {
            return {
                ...state,
                customer: action.payload
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const CustomerDetailContext = createContext({
    customer: initialValue,
    getCustomer: () => {},
    getOrders: () => {},
    getReviews: () => {},
    getAddresses: () => {},
    changeStatus: () => {},
})

export const CustomerDetailProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, {})
    const { setError } = useError();

    const getCustomer = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/customers/get_customer/'+id, options);

            return res.data;
        } catch (e) {
            if(e?.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e?.response?.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e?.response?.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const getOrders = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/customers/get_customer_orders/'+id, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const getAddresses = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/customers/get_address/'+id, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const getReviews = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/customers/get_reviews/'+id, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const changeStatus = async (customer_id, status) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/customers/change_status_customer/'+customer_id+"/"+status, options);

            dispatch({
                type: 'UPDATE_CUSTOMER_DATA',
                payload: res.data,
            })
            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return  null;
        }
    }


    if(state.status === 401){
        return <SessionOut />
    }

    return (
        <CustomerDetailContext.Provider
            value={{
                customer_list: state.customer_list,
                getCustomer,
                getOrders,
                getReviews,
                getAddresses,
                changeStatus
            }}
        >
            {children}
        </CustomerDetailContext.Provider>
    )
}

export default CustomerDetailContext
